module.exports = __webpack_public_path__ + "img/icn_user_disable.09a70367.svg";